const CUTOFF_COPY = {
  oneDay: 'Delivery within 1 business day',
  twoDay: 'Delivery within 2 business days'
}

module.exports = {
  CUTOFF_COPY
}
